import { Dialog } from '@trippath/shared';
import { useTranslation } from 'react-i18next';
import { encode } from 'uqr';

/** The modules around a code left white, as a reader needs. */
const QUIET = 4;

/**
 * A ticket's QR code drawn again from its text, to show from the phone at the door of the bus:
 * black on white whatever the theme, as large as the screen allows, its number under it.
 */
export function TicketCode({
  code,
  name,
  reference,
  onClose,
}: {
  code: string;
  name: string;
  reference: string | null;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const { data, size } = encode(code, { border: 0 });
  const dark = data.flatMap((row, y) =>
    row.flatMap((on, x) => (on ? [`M${String(x + QUIET)} ${String(y + QUIET)}h1v1h-1z`] : [])),
  );
  const side = size + QUIET * 2;
  return (
    <Dialog open onClose={onClose} title={t('ticketCode.title', { name })}>
      <div className="ticket-code">
        <svg
          viewBox={`0 0 ${String(side)} ${String(side)}`}
          role="img"
          aria-label={t('ticketCode.code', { code })}
          shapeRendering="crispEdges"
        >
          <rect width={side} height={side} fill="#fff" />
          <path d={dark.join('')} fill="#000" />
        </svg>
        <p className="mono">{reference ?? code}</p>
        <p className="quiet">{t('ticketCode.hint')}</p>
      </div>
    </Dialog>
  );
}
